import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { TradeStatusEnum } from "src/services/interfaces/TradeStatusEnum";
import { TradePhaseEnum } from "src/services/interfaces/trade/TradePhaseEnum";
import RedirectButton from "src/components/Refatoracao/RedirectButton/RedirectButton";
import ViewPendencyButton from 'src/components/common/GenericButtons/Pendency/ViewPendency/ViewPendencyButton';
import WorkflowTradeList from "src/components/Refatoracao/TradeList/WorkflowTradeList";

export default function TradesPendenciesPage(props: RouteComponentProps<any>) {
    const wfStatus = [TradeStatusEnum.Pendencia];
    const wfPhases = [
        TradePhaseEnum.ContractInformation,
        TradePhaseEnum.LegalCertificates,
        TradePhaseEnum.DocumentValidation,
        TradePhaseEnum.DocumentApproval,
        TradePhaseEnum.Analysis,
        TradePhaseEnum.Diligence,
        TradePhaseEnum.LawyerCompliance,
        TradePhaseEnum.SpecialSituation,
        TradePhaseEnum.PreCartorio,
        TradePhaseEnum.Cartorio,
        TradePhaseEnum.DigitalCertificate,
        TradePhaseEnum.Funding,
        TradePhaseEnum.ContractSignature
    ];
    const cardTitle = "Minhas Operações com Pendências";

    return (
        <WorkflowTradeList listStatus={wfStatus} listPhase={wfPhases} cardTitle={cardTitle} isArchiveEnabled={true} showArchivedTrades={false}>
            <RedirectButton icon="edit" buttonText="Editar" redirectWithTradeId={true} urlRedirect="/monitor/manual-trade/edit/" {...props} />
            <RedirectButton icon="eye" buttonText="Visualizar Operação" redirectWithTradeId={true} urlRedirect="/venda/" {...props} />
            <ViewPendencyButton />
        </WorkflowTradeList>
    );
}



// WEBPACK FOOTER //
// ./src/pages/monitor/operacoes/pendencia/TradesPendencies.page.tsx